import {BaseApiService} from "../BaseApiService";

export class PostApiService extends BaseApiService<object> {

    constructor() {
        super("Post");
    }

    public getByCategory(category: string){
        const url = this.prefixUrl + '/GetByCategory?category=' + category;

        return this.getRequest(url);
    }

    public getNews(limit: number){
        const url = this.prefixUrl + '/GetNews?limit=' + limit;

        return this.getRequest(url);
    }

    public getAgenda(limit: number){
        const url = this.prefixUrl + '/GetAgenda?limit=' + limit;

        return this.getRequest(url);
    }

    public getAnnouncement(limit: number){
        const url = this.prefixUrl + '/GetAnnouncement?limit=' + limit;

        return this.getRequest(url);
    }

    public getGallery(limit: number){
        const url = this.prefixUrl + '/GetGallery?limit=' + limit;

        return this.getRequest(url);
    }

    public getStaff(limit: number){
        const url = this.prefixUrl + '/GetStaff?limit=' + limit;

        return this.getRequest(url);
    }

    public readAgendaDetail(slug: string){
        const url = this.prefixUrl + '/ReadAgendaDetail?slug=' + slug;

        return this.getRequest(url);
    }

    public readAnnouncementDetail(slug: string){
        const url = this.prefixUrl + '/ReadAnnouncementDetail?slug=' + slug;

        return this.getRequest(url);
    }

    public readNewsDetail(slug: string){
        const url = this.prefixUrl + '/ReadNewsDetail?slug=' + slug;

        return this.getRequest(url);
    }

}


// WEBPACK FOOTER //
// ./src/core/api/post/PostApiService.tsx